export default __webpack_public_path__ + "static/media/close.ea02de25.svg";